import { APP_INITIALIZER, enableProdMode, importProvidersFrom } from '@angular/core';


import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withHashLocation } from '@angular/router';
import { OrderByPipe } from '@sl/sl-angular-library';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { LoadingInterceptor } from './app/core/services/interceptors/loading/loading-interceptor.service';
import { RoleService } from './app/core/services/role.service';
import { InjectorContainerModule } from './app/injector-container/injector-container.module';
import { AuthInterceptor } from './app/interceptors/auth/auth.interceptor';
import { TermPipe } from './app/shared/pipes/term.pipe';
import { environment } from './environments/environment';

function initializeApp(roleService: RoleService) {
  return () => roleService.loadRoles();
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(InjectorContainerModule, ReactiveFormsModule),
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [RoleService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(routes, withHashLocation()),
    DatePipe,
    TermPipe,
    OrderByPipe
  ]
})
  .catch(err => console.error(err));
